import { DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFrCa from '@angular/common/locales/fr-CA';
import { NgModule, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LanguageComponent } from '@compounds/language/1.0';

import {
  createTranslateLoader,
  DEFAULT_LANGUAGE,
  I18nModule,
  LANGUAGES,
  TRANSLATIONS,
} from '@modules/i18n/1.0';
import { EmptyMissingTranslationHandler } from '@modules/i18n/1.0/empty-missing-translation-handler';

import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { DateTranslatePipe } from '@pipes/date-translate/1.0';
import { ImgTranslatePipe } from '@pipes/img-translate/1.0';
import { LinkTranslatePipe } from '@pipes/link-translate/1.0';
import { NumberTranslatePipe } from '@pipes/number-translate/1.0';
import { KeyToLabelPipe } from '@pipes/key-to-label/1.0/key-to-label.pipe';

import * as translations from '../assets/i18n';

registerLocaleData(localeFrCa);
registerLocaleData(localeEs);
registerLocaleData(localeEn);

const defaultLanguage = localStorage.getItem('defaultLanguage') || 'en-US';

@NgModule({
  imports: [
    RouterModule,
    TranslateModule.forChild({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: EmptyMissingTranslationHandler,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, PLATFORM_ID, TRANSLATIONS],
      },
    }),
    I18nModule.forRoot(
      { provide: TRANSLATIONS, useValue: translations },
      { provide: DEFAULT_LANGUAGE, useValue: defaultLanguage },
      { provide: LANGUAGES, useValue: ['en-US', 'es-ES', 'fr-CA'] },
    ),
    ImgTranslatePipe,
    LinkTranslatePipe,
    DateTranslatePipe,
    NumberTranslatePipe,
    KeyToLabelPipe,
    LanguageComponent,
  ],
  providers: [DecimalPipe],
  exports: [
    I18nModule,
    ImgTranslatePipe,
    LinkTranslatePipe,
    DateTranslatePipe,
    NumberTranslatePipe,
    KeyToLabelPipe,
  ],
})
export class AppTranslateModule {}
